import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../index';
import { getAllUnits, createUnit as createUnitAPI, updateUnit as updateUnitAPI, syncTGASCrapper as syncTGASCrapperAPI } from 'api/units';
import { store } from 'store';

export const initialState = {
    list: [],
    total: 0,
    error: [],
    isLoading: false,
    isSaving: false,
    rowsPerPage: 10,
    currentPage: 1,
    searchQuery: '',
    sorting: {
        field: 'unitcode',
        value: 1
    }
};

const slice = createSlice({
    name: 'units',
    initialState,
    reducers: {
        setUnitsList(state, action) {
            state.list = action.payload.data;
            state.total = action.payload.total;
            state.isLoading = false;
        },
        setIsLoading(state, action) {
            state.isLoading = action.payload;
            if (action.payload === true) state.error = [];
        },
        setIsSaving(state, action) {
            state.isSaving = action.payload;
        },
        setErrors(state, action) {
            state.error = action.payload;
        },
        setUnitsCurrentPage(state, action) {
            state.currentPage = action.payload;
        },
        setSearchQuery(state, action) {
            state.currentPage = 1;
            state.searchQuery = action.payload;
        },
        setUnitsRowsPerPage(state, action) {
            state.rowsPerPage = action.payload;
            state.currentPage = 1;
        },
        setSorting(state, action) {
            state.currentPage = 1;
            state.sorting = action.payload;
        },
        resetUnitsState() {
            return initialState;
        }
    }
});

export default slice.reducer;

export function fetchUnitsList() {
    return async () => {
        await getListUnits();
    };
}

export function initialLoadUnitsData() {
    return async () => {
        await dispatch(slice.actions.resetUnitsState());
        await getListUnits();
    };
}

export function unitsCurrentPage(val) {
    return async () => {
        await dispatch(slice.actions.setUnitsCurrentPage(val));
        await getListUnits();
    };
}

export function unitsRowsPerPage(val) {
    return async () => {
        await dispatch(slice.actions.setUnitsRowsPerPage(val));
        await getListUnits();
    };
}

export function searchUnitsList(query) {
    return async () => {
        dispatch(slice.actions.setSearchQuery(query));
        await getListUnits();
    };
}

export function setUnitsSorting(val) {
    return async () => {
        dispatch(slice.actions.setSorting(val));
        await getListUnits();
    };
}

export function createUnit(unitData) {
    return async () => {
        try {
            dispatch(slice.actions.setIsSaving(true));
            const response = await createUnitAPI(unitData);
            dispatch(slice.actions.setIsSaving(false));

            await getListUnits();

            return response;
        } catch (err) {
            dispatch(slice.actions.setIsSaving(false));
            dispatch(slice.actions.setErrors([err.message]));
            throw err;
        }
    };
}

export function updateUnit(unitId, unitData) {
    return async () => {
        try {
            dispatch(slice.actions.setIsSaving(true));
            const response = await updateUnitAPI(unitId, unitData);
            dispatch(slice.actions.setIsSaving(false));

            await getListUnits();

            return response;
        } catch (err) {
            dispatch(slice.actions.setIsSaving(false));
            dispatch(slice.actions.setErrors([err.message]));
            throw err;
        }
    };
}

export function syncTGASCrapper(unitId) {
    return async () => {
        try {
            dispatch(slice.actions.setIsSaving(true));
            const response = await syncTGASCrapperAPI(unitId);
            dispatch(slice.actions.setIsSaving(false));

            await getListUnits();

            return response;
        } catch (err) {
            dispatch(slice.actions.setIsSaving(false));
            dispatch(slice.actions.setErrors([err.message]));
            throw err;
        }
    };
}

async function getListUnits() {
    try {
        dispatch(slice.actions.setIsLoading(true));
        const storeData = store.getState();
        const { currentPage, rowsPerPage, searchQuery, sorting } = storeData.units;

        const units = await getAllUnits({
            perPage: rowsPerPage,
            pageNo: currentPage,
            query: searchQuery,
            sortField: sorting?.field || 'unitcode',
            sorting: sorting?.value || 1
        });

        if (units?.success && units?.data) {
            dispatch(slice.actions.setUnitsList(units.data));
        } else {
            dispatch(slice.actions.setUnitsList({ data: [], total: 0 }));
        }
    } catch (err) {
        console.error('Error fetching units:', err);
        dispatch(slice.actions.setIsLoading(false));
        dispatch(slice.actions.setErrors([err.message]));
    }
}
